import React from "react";
import {
	BarChartOutlined,
	CopyOutlined,
	DatabaseOutlined,
	EnvironmentOutlined,
	HistoryOutlined,
	SyncOutlined,
} from "@ant-design/icons";
import { BulkOperationCategoryKey } from "../../utils/bulkOperationsConfig";
import AmkOrders from "./amk-orders";
import ClientReports from "./client-reports";
import DuplicatePayments from "./duplicate-payments";
import HistoryManagement from "./history-management";
import SectionIdCategory from "./section-id";
import StatusUpdates from "./status-updates";

export interface CategoryDefinition {
	key: BulkOperationCategoryKey;
	/** Key inside the `categories` localization sub-namespace. */
	stringsKey: string;
	fallbackLabel: string;
	fallbackDescription: string;
	icon: React.ReactNode;
	component: React.ReactNode;
}

// Adding a category = one entry here + one key in utils/bulkOperationsConfig.ts
// (so it can be enabled per country) + one block of localization strings.
export const CATEGORIES: CategoryDefinition[] = [
	{
		key: "amk-orders",
		stringsKey: "amkOrders",
		fallbackLabel: "AMK Orders",
		fallbackDescription:
			"Status and balance operations for orders delivered by AMK",
		icon: <DatabaseOutlined />,
		component: <AmkOrders />,
	},
	{
		key: "history-management",
		stringsKey: "historyManagement",
		fallbackLabel: "Menaxhimi i Historikut",
		fallbackDescription:
			"View, add and delete an order's status history rows",
		icon: <HistoryOutlined />,
		component: <HistoryManagement />,
	},
	{
		key: "section-id",
		stringsKey: "sectionId",
		fallbackLabel: "Section ID",
		fallbackDescription:
			"Move orders registered against the wrong country to the right zone",
		icon: <EnvironmentOutlined />,
		component: <SectionIdCategory />,
	},
	{
		key: "status-updates",
		stringsKey: "statusUpdates",
		fallbackLabel: "Bulk Status Updates",
		fallbackDescription:
			"Correct the status of orders that did not get the right one",
		icon: <SyncOutlined />,
		component: <StatusUpdates />,
	},
	{
		// The only category that is a second picker rather than a screen: it holds three
		// separate reports, each with its own filters and its own Excel export.
		key: "client-reports",
		stringsKey: "clientReports",
		fallbackLabel: "Raporte të Klientëve",
		fallbackDescription:
			"Kliente qe kane ndaluar porosite, pa porosi ne periudhe, dhe aktiviteti i nje klienti",
		icon: <BarChartOutlined />,
		component: <ClientReports />,
	},
	{
		key: "duplicate-payments",
		stringsKey: "duplicatePayments",
		fallbackLabel: "Pagesa të Dyfishuara",
		fallbackDescription:
			"Find orders paid twice and remove the duplicate payment",
		icon: <CopyOutlined />,
		component: <DuplicatePayments />,
	},
];

export const findCategory = (
	key: string | undefined
): CategoryDefinition | undefined =>
	CATEGORIES.find((category) => category.key === key);
